// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jNLgLD8MHVQIAYCo5mhr{gap:4px;max-width:312px;display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `jNLgLD8MHVQIAYCo5mhr`
};
export default ___CSS_LOADER_EXPORT___;
